// extracted by mini-css-extract-plugin
export default {"conradLogo":"SiteNav_conradLogo__iX3-G","small":"SiteNav_small__cfd-U"};